export const PAGE_SIZE = 20;

export const errorMessage = (err, fallback) => err?.responseMessage || err?.message || fallback;

export const formatDateTime = (value) => (value
    ? new Date(value).toLocaleString(undefined, { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' })
    : '—');

export const fileName = (uri) => (uri || '').split('/').filter(Boolean).pop() || '';

export const num = (v) => Number(v) || 0;

/** Episode counts (status → number) from the batch detail's [{status, count}] rows. */
export const countsByStatus = (rows) => (rows || []).reduce((acc, r) => {
    acc[r.status] = num(r.count);
    return acc;
}, {});

export const newRequestId = () => (window.crypto?.randomUUID
    ? window.crypto.randomUUID()
    : `req-${Date.now()}-${Math.random().toString(36).slice(2)}`);
